import React from 'react';
import cx from 'classnames';

const SkeletonElement = ( {type = 'skeleton-custom', className} ) => {
    return (
        <div data-testid="SkeletonElement" className={cx( 'skeleton pulse', type, className )}>&nbsp;</div>
    );
};

const ArticleTile = ( {className} ) =>
    <div className={className}>
        <SkeletonElement type="thumbnail-full" className="mb-4"/>
        <SkeletonElement type="title"/>
        <SkeletonElement type="text"/>
        <SkeletonElement type="text"/>
    </div>

const Paragraph = ( {className} ) =>
    <div className={className}>
        <SkeletonElement type="title"/>
        <SkeletonElement type="text"/>
        <SkeletonElement type="text"/>
    </div>

const NavListVertical = ( {className} ) =>
    <div className={className}>
        <SkeletonElement type="navLink"/>
        <SkeletonElement type="navLink ml-6"/>
        <SkeletonElement type="navLink ml-6"/>
        <SkeletonElement type="navLink"/>
        <SkeletonElement type="navLink ml-6"/>
        <SkeletonElement type="navLink ml-6"/>
        <SkeletonElement type="navLink ml-6"/>
        <SkeletonElement type="navLink"/>
        <SkeletonElement type="navLink ml-6"/>
    </div>

SkeletonElement.ArticleTile = ArticleTile;
SkeletonElement.Paragraph = Paragraph;
SkeletonElement.NavListVertical = NavListVertical;

export default SkeletonElement;
